import { FunctionComponent, useEffect } from 'react';

import { Options } from 'chartjs-plugin-datalabels/types/options';
import { IChartWithBars } from 'PDF/components/Charts/types';
import { useGenerateImageFromCharts } from 'PDF/hooks/useGenerateImageFromCharts';

import { ChartWithBars } from './ChartWithBars';

interface IChartWithBarsWrapper {
  info: IChartWithBars;
  aspectRatio: number;
  updateState: (title: string, src: string) => void;
  customDataLabels?: Options;
  withDataLabeInsideBar?: boolean;
}

export const ChartWithBarsWrapper = ({
  aspectRatio,
  info,
  updateState,
  customDataLabels,
  withDataLabeInsideBar,
}: IChartWithBarsWrapper) => {
  const [chartPortal, chartImgSrc] = useGenerateImageFromCharts(ChartWithBars as FunctionComponent, {
    aspectRatio,
    info,
    customDataLabels,
    withDataLabeInsideBar,
  });

  useEffect(() => {
    if (chartImgSrc) {
      updateState(info.title, chartImgSrc);
    }
  }, [chartImgSrc]);

  return <>{chartPortal}</>;
};
